import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface SearchState {
  query: string;
  isSearching: boolean;
  selectedOption: string;
}

const initialState: SearchState = {
  query: "",
  isSearching: false,
  selectedOption: "total",
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    clearQuery: (state) => {
      state.query = "";
    },
    setIsSearching: (state, action: PayloadAction<boolean>) => {
      state.isSearching = action.payload;
    },
    setSelectedOption: (state, action: PayloadAction<string>) => {
      state.selectedOption = action.payload;
    },
  },
});

export const searchActions = searchSlice.actions;
export const searchReducer = searchSlice.reducer;